import { defineStore } from 'pinia';
import { store } from '/@/store';
import SheetWebsocket from '/@/hooks/core/useSocket';
import { createLocalStorage } from '/@/utils/cache';
import { TOKEN_KEY } from '/@/enums/cacheEnum';
import { WebsocketUrlApi } from '/@/api/common';
import { notification } from 'ant-design-vue';
import { useUserStoreWithOut } from '/@/store/modules/user';
// import { useWarningWithOut } from '/@/store/modules/warningNotice';

interface ServiceState {
  sheetCount: number;
  notReadNumber: number;
  ws: any;
}
export const useServiceStore = defineStore({
  id: 'service',
  state: (): ServiceState => ({
    sheetCount: 0,
    notReadNumber: 0,
    ws: null,
  }),
  getters: {
    getSheetCount(): number {
      return this.sheetCount;
    },
    getWebsocket(): any {
      return this.ws;
    },
    getNotReadNumber(state): number {
      return state.notReadNumber;
    },
  },
  actions: {
    async initWebSocket(): Promise<void> {
      console.log('initWebsocket');
      let ls = createLocalStorage();
      if (!ls.get(TOKEN_KEY) || window.location.hash === '#/login') return;
      this.ws = new SheetWebsocket(
        `${WebsocketUrlApi}?Goose-Video-Access-Token=${encodeURIComponent(
          ls.get(TOKEN_KEY)
        )}`
      );
      this.ws.onmessage = this.onCheckSheetCountMessage;
    },
    setSheetCount(count: number): void {
      this.sheetCount = count;
    },
    onCheckSheetCountMessage(event: Recordable): void {
      try {
        const data = JSON.parse(event.data);
        console.log('event.data', data);
        switch (data.type) {
          case 'sheetNum':
            this.setSheetCount(data.value);
            notification.info({
              key: 'sheetNum',
              message: '待处理工单提醒',
              description: `您有${data.value}条新的待处理工单，请及时处理。`,
              top: '48px',
            });
            break;
          case 'offline':
            console.log('offline==>', data.value);
            const userStore = useUserStoreWithOut();
            userStore.updateLine(0);
            break;
          case 'notice':
            console.log('notice==>', data.value);
            // const warningStore = useWarningWithOut();
            this.setNotReadNumber(data.value);
            break;
          case 'heartbeat':
            break;
          default:
            break;
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    setNotReadNumber(num: any) {
      console.log('setNotReadNumber==>', num);

      this.notReadNumber = num;
    },
  },
});

// Need to be used outside the setup
export function useServiceStoreWithOut() {
  return useServiceStore(store);
}
